import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'default' | 'lg';
}

const sizeMap = {
  sm: 'h-4 w-4',
  default: 'h-6 w-6',
  lg: 'h-8 w-8',
};

const Spinner: React.FC<SpinnerProps> = ({ className, size = 'default' }) => (
  <Loader2 className={cn(sizeMap[size], 'animate-spin text-primary-600', className)} />
);

interface SpinnerOverlayProps {
  spinning?: boolean;
  children?: React.ReactNode;
  tip?: string;
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({
  spinning = true,
  children,
  tip,
  size = 'default',
  className,
}) => {
  if (children) {
    return (
      <div className={cn('relative', className)}>
        {spinning && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/60">
            <div className="flex flex-col items-center gap-2">
              <Spinner size={size} />
              {tip && <span className="text-xs text-neutral-500">{tip}</span>}
            </div>
          </div>
        )}
        <div className={spinning ? 'opacity-50 pointer-events-none' : ''}>{children}</div>
      </div>
    );
  }

  if (!spinning) return null;

  return (
    <div className={cn('flex items-center justify-center p-4', className)}>
      <div className="flex flex-col items-center gap-2">
        <Spinner size={size} />
        {tip && <span className="text-xs text-neutral-500">{tip}</span>}
      </div>
    </div>
  );
};

export { Spinner, SpinnerOverlay };
